// extracted by mini-css-extract-plugin
export default {"container":"gradient-button_container__kFnZm","yellowPink":"gradient-button_yellowPink__1FCvs","documentCustomHeader":"gradient-button_documentCustomHeader__3O0nb"};